/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import ShortenerProvider from 'app/redux/Providers/ShortenerProvider.jsx';
import DomainProvider from 'app/redux/Providers/DomainProvider.jsx';
import { compose } from 'redux';

class HelperPanel extends React.Component {
    constructor(props) {
        super(props);

        this.props.getShorteners();
        this.props.getDomains();

        this.updateField = this.updateField.bind(this);

    }

    updateField(e) {

        let value = e.currentTarget.value,
            info = value.split("-"),
            id = 0,
            fieldEvent = {
                currentTarget: {
                    dataset: {
                        field: ''
                    }
                },
                target: {
                    value: 0
                }
            },
            resetEvent = {
                currentTarget: {
                    dataset: {
                        field: ''
                    }
                },
                target: {
                    value: 0
                }
            };

        if (info[0] === 'shortener') {
            fieldEvent.currentTarget.dataset.field = "social.saID";
            resetEvent.currentTarget.dataset.field = "social.pdID";
        } else if (info[0] === 'domain') {
            fieldEvent.currentTarget.dataset.field = "social.pdID";
            resetEvent.currentTarget.dataset.field = "social.saID";
        }

        fieldEvent.target.value = info[1];
        resetEvent.target.value = 0;

        this.props.changeHandler(resetEvent);
        this.props.changeHandler(fieldEvent);

    }

    render() {
        let currentPanel = null,
            shortenerOptions = [
                {value: 'shortener-0', label: 'dlvr.it'},
                {value: 'domain-1', label: 'Don\'t shorten links'}
            ],
            domainOptions = [], // no domain option is returned by API call so no need to create it here
            selectedShortener = this.props.social.saID ? 'shortener-' + this.props.social.saID : 0,
            selectedDomain = parseInt(this.props.social.pdID, 10) ? 'domain-' + this.props.social.pdID : 0,
            i = 0,
            controlState = this.props.getControlState(),
            selectedOption = 0,
            name = '';

        if (selectedDomain) {
            selectedOption = selectedDomain;
        } else if (selectedShortener) {
            selectedOption = selectedShortener;
        }

        if (this.props.shorteners.length) {
            for (i = 0; i < this.props.shorteners.length; ++i) {
                name = this.props.shorteners[i].name;
                if (parseInt(this.props.shorteners[i].ssID, 10) > 1) {
                    name = ConstantMixin.getShortenServiceByCode(this.props.shorteners[i].ssID) + " - " + name;
                }
                shortenerOptions.push({
                    value: 'shortener-' + this.props.shorteners[i].id,
                    label: name
                });
            }
        }

        if (this.props.domains.length) {
            for (i = 0; i < this.props.domains.length; ++i) {
                shortenerOptions.push({
                    value: 'domain-' + this.props.domains[i].id,
                    label: this.props.domains[i].domain
                });
            }
        }

        currentPanel = (
            <div>
                <fieldset>
                    <legend>Link Shortening Service or Custom Domain<HelpButton which="shortenerOverride" service={this.props.social.psID}/></legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="saID" errors={state.errors}/>
                            );
                        }}/>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SOCIAL_CREATE', 'SOCIAL_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="paID" errors={state.errors}/>
                            );
                        }}/>
                    <StyledSelect
                        options={shortenerOptions}
                        value={selectedOption}
                        onChange={this.updateField}
                        selectClass="large"
                        controlState={controlState} />
                </fieldset>
                {this.props.getUrlAppend()}
            </div>
        );

        return this.props.getPanelOutput(currentPanel);
    }

};

const enhance = compose(
    SocialPanelModule,
    ShortenerProvider,
    DomainProvider
);

export default enhance(HelperPanel);
